module.exports = __webpack_public_path__ + "assets/img/bed-mng.115624e4.svg";